<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Product Demand Report Today",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DataTable,
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        title: "Product Demand Report Today",
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Product Demand Report Today",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Product Demand Report Today",
          active: true,
        },
      ],
      totalRows: 1,
      total_amount: 0,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsProductDemandServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "product_name",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "quantity",
          sortable: true,
          label: "QUANTITY",
        },
        {
          key: "amount",
          sortable: true,
          label: "AMOUNT",
        },
      ],
      json_fields: {
        PRODUCT_NAME: "product_name",
        QUANTITY: "quantity",
        AMOUNT: "amount",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("products", [
      "ProductDemand",
      "ProductDemandPagination",
      "ProductDemandPaginated",
      "FilterStatus",
    ]),

    rows() {
      return this.IsProductDemandServerPaginated
        ? this.ProductDemandPagination?.total
        : this.ProductDemand
        ? this.ProductDemand.length
        : 0;
    },

    perPage: {
      get() {
        if (this.IsProductDemandServerPaginated) {
          return (
            this.ProductDemandPagination.per_page ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsProductDemandServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchProductDemand(this.data);
        }
      },
    },

    currentPage: {
      get() {
        return this.ProductDemandPaginated && this.ProductDemandPagination
          ? this.ProductDemandPagination.current_page
          : 1;
      },
      set(value) {
        if (this.ProductDemandPaginated) {
          this.data.page = value;
          this.handlePageChange(value);
        }
      },
    },
  },

  methods: {
    ...mapActions({
      FetchProductDemand: "products/fetchProductdemand",
    }),

     thousandSeperator(m) {
      if (m === "" || m === undefined || m === null) {
        return m;
      }
      const str = m.toString();
      const integerPart = str.split(".")[0];
      return integerPart
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    ProductDemandData() {
      this.data.title =
        "Product Demand Report From " +
        this.data.datefrom +
        " To " +
        this.data.dateto;
      this.FetchProductDemand(this.data);
    },

    handlePageChange(newPage) {
      if (this.IsProductDemandServerPaginated) {
        this.data.page = newPage;
        this.FetchProductDemand(this.data);
      }
    },
  },

  created() {
    this.FetchProductDemand(this.data);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3
                  class="card-title mb-2 text-center"
                  v-html="data.title"
                ></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 mt-4">
                <download-excel
                  class="btn btn-info"
                  :data="ProductDemand"
                  :fields="json_fields"
                  :worksheet="'PRODUCT DEMAND REPORT ON' + currentdate"
                  type="csv"
                  :name="'Product_demand' + currentdate + '.xls'"
                >
                  Export Excel <i class="fa fa-download"></i>
                </download-excel>
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>FROM</label>
                <input
                  @change="ProductDemandData()"
                  type="date"
                  v-model="data.datefrom"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>TO</label>
                <input
                  @change="ProductDemandData()"
                  v-model="data.dateto"
                  type="date"
                  class="form-control"
                  v-limit-future-date
                />
              </div>
              <div class="col-md-2 mt-4">
                <button
                  class="btn btn-primary cursor-pointer"
                  type="button"
                  @click="ProductDemandData()"
                >
                  <span class="fa fa-filter cursor-pointer"></span> Filter
                  <b-spinner
                    v-show="FilterStatus"
                    variant="light"
                    small
                    role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
            
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <DataTable
                class="datatables"
                responsive="sm"
                :columns="fields"
                :rows="ProductDemand"
                :total-rows="rows"
                :pagination="ProductDemandPagination"
                :server-pagination="IsProductDemandServerPaginated"
                :loading="FilterStatus"
              >
                <template #cell(index)="{ index }">
                  {{ (currentPage - 1) * perPage + index + 1 }}
                </template>
                <template #cell(product_name)="{ row }">
                  {{ row.product_name }}
                </template>
                <template #cell(quantity)="{ row }">
                  {{ row.quantity }}
                </template>
                <template #cell(amount)="{ row }">
                  {{ thousandSeperator(row.amount) }}
                </template>
              </DataTable>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,
.page-link {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
